import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0b53ddee"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "lotteryMain"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "https://00853six.com/assets/swiper1-fc687c21.jpeg",
    alt: ""
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "https://00853six.com/assets/swiper2-3279e52f.jpeg",
    alt: ""
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "https://00853six.com/assets/swiper3-8c035527.jpeg",
    alt: ""
  }, null, -1);
});
var _hoisted_5 = {
  "class": "main-page"
};
var _hoisted_6 = {
  "class": "curtLottery"
};
var _hoisted_7 = {
  "class": "lotteryTitle"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "澳門六合彩", -1);
});
var _hoisted_9 = {
  "class": "period"
};
var _hoisted_10 = {
  "class": "mred"
};
var _hoisted_11 = {
  "class": "c"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
    "class": "mshow"
  }, "下期"), /*#__PURE__*/_createTextVNode("截止時間"), /*#__PURE__*/_createElementVNode("i", {
    "class": "mhide"
  }, "：")], -1);
});
var _hoisted_13 = {
  "class": "currentGame"
};
var _hoisted_14 = {
  "class": "nextDraw"
};
var _hoisted_15 = {
  "class": "nextDrawInner"
};
var _hoisted_16 = {
  "class": "countdown"
};
var _hoisted_17 = {
  "class": ""
};
var _hoisted_18 = {
  "class": ""
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", {
    "class": "dot"
  }, ":", -1);
});
var _hoisted_20 = {
  "class": ""
};
var _hoisted_21 = {
  "class": ""
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", {
    "class": "dot"
  }, ":", -1);
});
var _hoisted_23 = {
  "class": ""
};
var _hoisted_24 = {
  "class": ""
};
var _hoisted_25 = {
  "class": "lotteryActs"
};
var _hoisted_26 = {
  "class": "lotteryBtns"
};
var _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"buttons\" data-v-0b53ddee><button class=\"button-yellow\" data-v-0b53ddee> 開獎驗證 </button><div class=\"lotteryPledge\" data-v-0b53ddee><b data-v-0b53ddee><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1025 1024\" width=\"1em\" height=\"1em\" fill=\"currentColor\" data-v-0b53ddee><path d=\"M512 128a384 384 0 1 1-.043 768.043A384 384 0 0 1 512 128zm-19.2 553.259l76.501-248.363-16-1.408-91.52 11.69-4.693 13.995c3.755.086 6.955.256 9.6.512a17.067 17.067 0 0 1 13.227 7.254c2.986 4.266 4.266 9.088 3.84 14.293-.726 8.277-3.584 20.48-8.534 36.565l-51.754 166.955c-4.182 13.312-6.656 24.277-7.424 33.11-1.152 13.226 1.28 24.533 7.338 33.791a33.28 33.28 0 0 0 26.283 15.403c30.08 2.645 61.099-26.112 93.27-86.23l-8.363-7.935c-13.142 22.016-24.107 37.077-32.854 45.184-3.285 3.328-6.4 4.864-9.429 4.565-1.835-.128-3.413-1.365-4.779-3.797a12.715 12.715 0 0 1-1.706-7.51c.384-4.437 2.688-13.866 6.954-28.074zM554.496 384a41.301 41.301 0 0 0 30.293-12.459 41.301 41.301 0 0 0 12.544-30.208 41.43 41.43 0 0 0-12.373-30.208 41.344 41.344 0 0 0-30.421-12.458 40.96 40.96 0 0 0-30.166 12.458A41.43 41.43 0 0 0 512 341.333c0 11.776 4.139 21.846 12.501 30.208C532.907 379.82 542.848 384 554.54 384z\" data-v-0b53ddee></path></svg> 即時開獎驗證</b><p data-v-0b53ddee>開獎現場直播，同步播報中央電視臺1套視頻，開獎過程100%公開公正！</p></div></div>", 1);
var _hoisted_28 = {
  href: "/post",
  "class": "his"
};
var _hoisted_29 = {
  "class": "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5965",
  style: {
    "width": "1em",
    "height": "1em",
    "vertical-align": "middle",
    "fill": "currentcolor",
    "overflow": "hidden"
  }
};
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M245.034251 895.239428l383.063419-383.063419L240.001631 124.07997l0.070608-0.033769c-12.709463-13.137205-20.530592-31.024597-20.530592-50.731428 0-40.376593 32.736589-73.111135 73.115228-73.111135 19.705807 0 37.591153 7.819083 50.730405 20.528546l0.034792-0.035816 438.686251 438.681134-0.035816 0.034792c13.779841 13.281491 22.3838 31.915897 22.3838 52.586682 0 0.071631 0 0.106424 0 0.178055 0 0.072655 0 0.10847 0 0.144286 0 20.669762-8.603959 39.341007-22.3838 52.623521l0.035816 0.033769L343.426165 1003.661789l-0.180102-0.179079c-13.140275 12.565177-30.950919 20.313651-50.588165 20.313651-40.378639 0-73.115228-32.736589-73.115228-73.114205C219.544717 928.512229 229.432924 908.664182 245.034251 895.239428z",
    "p-id": "5966"
  }, null, -1);
});
var _hoisted_31 = [_hoisted_30];
var _hoisted_32 = {
  "class": "currentCode"
};
var _hoisted_33 = {
  "class": "currentCodeInner"
};
var _hoisted_34 = {
  "class": "mhide"
};
var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("strong", null, "澳門六合彩", -1);
});
var _hoisted_36 = {
  "class": "drawCode big"
};
var _hoisted_37 = {
  "class": "icon iconup",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5950",
  style: {
    "width": "1em",
    "height": "1em",
    "vertical-align": "middle",
    "fill": "currentcolor",
    "overflow": "hidden"
  }
};
var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M128.759037 245.033739l383.064442 383.064442 388.096039-388.097062 0.033769 0.070608c13.138228-12.709463 31.024597-20.528546 50.730405-20.528546 40.377616 0 73.114205 32.736589 73.114205 73.115228 0 19.705807-7.820106 37.591153-20.530592 50.730405l0.035816 0.034792-438.681134 438.685227-0.035816-0.035816c-13.280468 13.780865-31.915897 22.3838-52.585659 22.3838-0.071631 0-0.107447 0-0.178055 0-0.072655 0-0.10847 0-0.146333 0-20.669762 0-39.341007-8.601912-52.621475-22.3838l-0.035816 0.035816L20.336676 343.425653l0.179079-0.179079c-12.565177-13.139252-20.313651-30.951943-20.313651-50.587142 0-40.378639 32.736589-73.115228 73.114205-73.115228C95.485213 219.544205 115.334283 229.432413 128.759037 245.033739z",
    "p-id": "5951"
  }, null, -1);
});
var _hoisted_39 = [_hoisted_38];
import { record } from '@/utils/https.js';
import hisWrapper from '@/components/hisWrapper.vue';
import plaues from '@/components/playes.vue';
import zibo from '@/components/zibo.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
// 引入swiper样式（按需导入）
import 'swiper/css';
import 'swiper/css/pagination'; // 轮播图底面的小圆点

// 引入swiper核心和所需模块
import { Autoplay, Pagination } from 'swiper';
import axios from "axios"; //原生的axios
import { reactive } from 'vue';
export default {
  __name: 'page',
  setup: function setup(__props) {
    var t = new Date().getTime();
    // let kajing = reactive([])
    var kajing = [
    // {number: '00', sx: '马', nim: '火', style: '#ff2020', color: 'red'},
    // {number: '00', sx: '兔', nim: '火', style: '#00a1ff', color: 'blue'},
    // {number: '00', sx: '羊', nim: '土', style: '#43bb05', color: 'green'}, 
    // {number: '00', sx: '猪', nim: '木', style: '#43bb05', color: 'green'},
    // {number: '00', sx: '虎', nim: '木', style: '#00a1ff', color: 'blue'},
    // {number: '00', sx: '猴', nim: '金', style: '#43bb05', color: 'green'},
    // {number: '00', sx: '狗', nim: '火', style: '#ff2020', color: 'red'}
    {
      number: '00',
      sx: '马',
      nim: '火',
      style: 'red',
      color: 'red'
    }, {
      number: '00',
      sx: '兔',
      nim: '火',
      style: 'blue',
      color: 'blue'
    }, {
      number: '00',
      sx: '羊',
      nim: '土',
      style: 'green',
      color: 'green'
    }, {
      number: '00',
      sx: '猪',
      nim: '木',
      style: 'green',
      color: 'green'
    }, {
      number: '00',
      sx: '虎',
      nim: '木',
      style: 'blue',
      color: 'blue'
    }, {
      number: '00',
      sx: '猴',
      nim: '金',
      style: 'green',
      color: 'green'
    }, {
      number: '00',
      sx: '狗',
      nim: '火',
      style: 'red',
      color: 'red'
    }];
    var kajings = reactive([]);
    var videoShow = ref(false); //显示回放视频
    var newCode = ref({});
    var fiveArray = reactive([]);
    var fivedata = ref([]);
    var hours = ref([0, 0]);
    var minutes = ref([0, 0]);
    var seconds = ref([0, 0]);
    setInterval(function () {
      getDate();
      kajings = [];
      kajing.forEach(function (item) {
        var newItem = {
          color: item.style,
          nim: item.nim,
          number: item.number,
          style: item.style,
          sx: item.sx
        };
        if (!(parseInt(item.number) < 50 && parseInt(item.number) > 0)) {
          newItem.number = Math.floor(Math.random() * 49 + 1);
          newItem.color = colorarray[cons(newItem.number, numarray)];
          newItem.sx = sxarray[cons(newItem.number, sxCode)];
          if (newItem.number < 10) {
            newItem.number = "0" + newItem.number;
          } else {
            newItem.number = "" + newItem.number;
          }
        }
        kajings.push(newItem);
      });
    }, 100);
    var getDate = function getDate() {
      var kjtime_str = newCode.value.Year + "/" + newCode.value.Moon + "/" + newCode.value.Day + " " + newCode.value.Time + ":00 GMT+08:00";
      var kjtime = new Date(kjtime_str);
      var nowtime = new Date();
      var djs = (kjtime.getTime() - nowtime.getTime()) / 1000;
      if (djs < 0) {
        return false;
      }
      var h = Math.floor(djs / 3600);
      var m = Math.floor(djs % 3600 / 60);
      var s = Math.floor(djs % 3600 % 60);
      hours.value = tow(h).split('');
      minutes.value = tow(m).split('');
      seconds.value = tow(s).split('');
    };

    //简体字转繁体字
    var textChange = function textChange(n) {
      var jt = "龙马鸡猪";
      var ft = "龍馬雞豬";
      if (jt.indexOf(n) == -1) {
        return n;
      } else {
        var r = ft.substr(jt.indexOf(n), 1);
        return r;
      }
      return n;
    };
    var tow = function tow(n) {
      return n >= 0 && n < 10 ? '0' + n : '' + n;
    };
    var pclose = function pclose(e) {
      videoShow.value = e;
    };
    var codeArrays = reactive({});
    var videoBack = function videoBack(e) {
      videoShow.value = true;
      codeArrays = e;
    };
    onBeforeMount(function () {
      var url1 = "https://kj6.kkjj.finance/data/v_" + process.env.VUE_APP_TYPE_NAME + ".json?" + t;
      axios(url1).then(function (res) {
        var data = res.data;
        // console.log(data);
        data.Time = data.Time.replace('点', ':').replace('分', '');
        setTimeout(function () {
          kajing = [];
          for (var i = 1; i <= 7; i++) {
            kajing.push(data.Data[i]);
          }
        }, 2000);
        newCode.value = data;
      });
      record({
        lottery_id: process.env.VUE_APP_TYPE_CODE
      }).then(function (res) {
        var data = res.data.data;
        fivedata.value = data[0];
        data.forEach(function (item, i) {
          if (i < 5) {
            fiveArray.push(item);
          }
        });
        fiveArray.forEach(function (items) {
          items.open_number = items.open_number.split(',');
          items.sx = items.sx.split(',');
          items.color = items.color.split(',');
        });
      });
    });
    var hislist = ref(true);
    var hisListTit = function hisListTit() {
      hislist.value = !hislist.value;
    };

    // 在modules加入要使用的模块
    var modules = [Autoplay, Pagination];
    var router = useRouter();
    var navTozb = function navTozb() {
      //跳转直播页面
      router.push({
        path: '/live'
      });
    };

    //到计时

    //随机球
    var numarray = [[1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46], [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48], [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]];
    var cons = function cons(d, array) {
      var b = 0;
      for (var i = 0; i < array.length; i++) {
        for (var j = 0; j < array[i].length; j++) {
          if (array[i][j] == d) {
            b = i;
          }
        }
      }
      return b;
    };
    var codeArray = reactive([{
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }, {
      code: '40',
      color: 'red',
      sx: '猪'
    }]);
    var colorarray = ['blue', 'green', 'red'];
    var sxarray = ['兔', '虎', '牛', '鼠', '猪', '狗', '鸡', '猴', '羊', '马', '蛇', '龙'];
    var sxCode = [[1, 13, 25, 37, 49], [2, 14, 26, 38], [3, 15, 27, 39], [4, 16, 28, 40], [5, 17, 29, 41], [6, 18, 30, 42], [7, 19, 31, 43], [8, 20, 32, 44], [9, 21, 33, 45], [10, 22, 34, 46], [11, 23, 35, 47], [12, 24, 36, 48]];
    // setInterval(()=>{

    //     codeArray.forEach((item)=>{
    //         let c = Math.floor((Math.random()*49)+1);
    // kajing.push(item)
    //         item.number = c;
    //         item.style = colorarray[cons(c,numarray)]
    //         item.sx = sxarray[cons(c,sxCode)]  
    //     })
    // },500)

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        modules: modules,
        loop: true,
        "slides-per-view": 1,
        "space-between": 50,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          clickable: true
        },
        scrollbar: {
          draggable: true
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(SwiperSlide), null, {
            "default": _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_unref(SwiperSlide), null, {
            "default": _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }), _createVNode(_unref(SwiperSlide), null, {
            "default": _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, [_createElementVNode("span", _hoisted_9, [_createTextVNode("第"), _createElementVNode("i", _hoisted_10, _toDisplayString(_unref(newCode).Year + _unref(newCode).Nq), 1), _createTextVNode("期")]), _createElementVNode("span", _hoisted_11, [_hoisted_12, _createElementVNode("i", null, _toDisplayString(_unref(newCode).Year) + "-" + _toDisplayString(_unref(newCode).Moon) + "-" + _toDisplayString(_unref(newCode).Day) + " " + _toDisplayString(_unref(newCode).Time) + ":00", 1)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_17, _toDisplayString(_unref(hours)[0]), 1), _createElementVNode("li", _hoisted_18, _toDisplayString(_unref(hours)[1]), 1), _hoisted_19, _createElementVNode("li", _hoisted_20, _toDisplayString(_unref(minutes)[0]), 1), _createElementVNode("li", _hoisted_21, _toDisplayString(_unref(minutes)[1]), 1), _hoisted_22, _createElementVNode("li", _hoisted_23, _toDisplayString(_unref(seconds)[0]), 1), _createElementVNode("li", _hoisted_24, _toDisplayString(_unref(seconds)[1]), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("button", {
        "class": "button-primary",
        onClick: _cache[0] || (_cache[0] = function () {
          return _unref(navTozb) && _unref(navTozb).apply(void 0, arguments);
        })
      }, " 直播 ")]), _createElementVNode("a", _hoisted_28, [_createTextVNode("歷史開獎查詢 "), (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31))])])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("h3", _hoisted_34, [_hoisted_35, _createTextVNode("第 "), _createElementVNode("b", null, _toDisplayString(_unref(newCode).Year + _unref(newCode).Qi), 1), _createTextVNode(" 期 ")]), _createElementVNode("ul", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kajings), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": _normalizeClass(item.style),
          key: index
        }, [_createElementVNode("strong", null, _toDisplayString(item.number), 1), _createElementVNode("em", null, _toDisplayString(textChange(item.sx)), 1)], 2);
      }), 128))])])])])]), _createElementVNode("h3", {
        "class": "hisListTit mshow",
        onClick: _cache[1] || (_cache[1] = function () {
          return _unref(hisListTit) && _unref(hisListTit).apply(void 0, arguments);
        })
      }, [_createTextVNode(" 查看近五期 "), (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39))]), _unref(hislist) ? (_openBlock(), _createBlock(hisWrapper, {
        key: 0,
        onVideoBack: _unref(videoBack),
        fiveArray: _unref(fiveArray)
      }, null, 8, ["onVideoBack", "fiveArray"])) : _createCommentVNode("", true)])]), _createVNode(plaues, {
        videoShow: _unref(videoShow),
        codeArray: _unref(codeArrays),
        onPclose: _unref(pclose)
      }, null, 8, ["videoShow", "codeArray", "onPclose"])], 64);
    };
  }
};